import {Component, ElementRef, EventEmitter, input, output, Output, viewChild, ViewChild} from '@angular/core';
import {Button} from 'primeng/button';
import {NgClass} from '@angular/common';
@Component({
  selector: 'upload-document',
  standalone: true,
  templateUrl: './upload-document.component.html',
  imports: [
    Button,
    NgClass,
  ],
})
export class UploadDocumentComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  disabled = input<boolean>(false);
  filesSelected = output<File[]>();

  openFileDialog() {
    if (this.disabled()) return;
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    this.handleFiles(Array.from(input.files));
    input.value = '';
  }

  onDragOver(event: DragEvent) {
    if (this.disabled()) return;
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (this.disabled()) return;

    const files = event.dataTransfer?.files;
    if (!files?.length) return;

    this.handleFiles(Array.from(files));
  }

  private handleFiles(files: File[]) {
    this.filesSelected.emit(files);
  }
}
